import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CourseCard from './CourseCard';
import axios from 'axios'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  card: {
    // padding: theme.spacing.unit * 2,
    marginTop: 10,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
});

class AppCourse extends Component {

  constructor(props) {
    super(props);
    this.state = {
      courses: []
    }
    // axios.get('https://www.openedu.tw/rest/courses/listShortInfo')
    //   .then((res) => {
    //     let courses = JSON.parse(res);
    //     for (var i = 1; i <= 10; i++) {
    //       let course = courses[i];
    //       this.setState({ courses: [this.state.courses, course] })
    //     }
    //   });
    axios.get('/data/cv_courses.json')
    .then((res) => {
      // console.log(res)
      let courses = res.data;
      let temp = []
      for (var i = 0; i <= 200; i++) {
        let course = courses[i];
        let newCourse = {
          courseId: course.id,
          courseName : course.name,
          courseOffer : course.org,
          imgUrl: 'https://courses.openedu.tw' + course.courseImgUrl
        }
        temp.push(newCourse)
      }
      this.setState({ courses: temp })
    });
  }

  // addCourse() {
  //   this.setState({ courses: [this.state.courses,] })
  // }

  com

  componentWillUpdate() {

  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Grid container spacing={16}>
          {
            this.state.courses.map((item, i) => (
              <Grid item xs={6} sm={4} md={4} lg={3} xl={2} key={i}>
                <CourseCard  courseName={item.courseName} courseOffer={item.courseOffer} imgUrl={item.imgUrl} />
              </Grid>
            ))
          }
          {/* <Typography noWrap>{'App course'}</Typography> */}
          {/* <Grid item xs={6} sm={4} md={4} lg={3} xl={2}>
            <CourseCard className={classes.card} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2}>
            <CourseCard className={classes.card} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2}>
            <CourseCard className={classes.card} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2}>
            <CourseCard className={classes.card} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2}>
            <CourseCard className={classes.card} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2}>
            <CourseCard className={classes.card} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2}>
            <CourseCard className={classes.card} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2}>
            <CourseCard className={classes.card} />
          </Grid> */}
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(AppCourse);


// WEBPACK FOOTER //
// ./src/components/AppCourse/AppCourse.jsx